import "./Flights.module.css";
import Header from "@/reusable_sections/Header";
import PremiumServices from "./sections/PremiumServices";
import DelhiDropping from "./sections/DelhiDropping";
import LandingPage from "./sections/LandingPage";
import SiteHeader from "./sections/SiteHeader";
import TheM4SelfBalancingExperience from "./sections/TheM4SelfBalancingExperience";
import WhyHabeshaPastry from "./sections/WhyHabeshaPastry";
import Footer from "@/reusable_sections/Footer";
export default function FlightsPage() {
  return <div>
      <Header />
      <PremiumServices />
      <LandingPage />
      <DelhiDropping />
      <SiteHeader />
      <TheM4SelfBalancingExperience />
      <WhyHabeshaPastry />
      <Footer />
    </div>;
}